<template>
    <div class="generateQrCode">
        <template v-if="erCodeShow">
            <div class="generateQrCode_huan" @click="getSwitchUserBox">
                <img src="@/assets/generateQrCode/passworde.png" alt=""/>
            </div>
            <div class="generateQrCode_code">
                <p class="code_title">扫码登录</p>
                <!-- 二维码 -->
                <div class="code_img_box1" v-show="!weChatshow">
                    <!-- 二维码失效时的展示 -->
                    <div class="code_img_boxRef" v-show="canClick" @click="refreshPage">
                        <div class="code_img_boxText">
                            <i class="el-icon-refresh-right"></i>
                            <p>二维码失效</p>
                            <p class="boxRef_cur">刷新重新获取</p>
                        </div>
                    </div>
                    <!-- 二维码展示 -->
                    <div class="code_img_box">
                        <img :src="erCode" alt="" class="code_img"/>
                    </div>
                </div>
                <!-- 微信登录的二维码 -->
                <div class="code_img_box1 code_img_box2" v-show="weChatshow">
                    <img src="../../assets/generateQrCode/lines.png" alt="" class="code_img_box2_img">
                    <div id="weixin"></div>
                    <!-- <div class="icon_success el-icon-success" v-if="weChatIcons"></div> -->
                </div>
                <!-- 提示语 -->
                <div class="code_text_box" v-show="!weChatshow">
                    <p class="code_text_p">请使用</p>
                    <span class="code_text_span"> 增材云APP </span>
                    <p class="code_text_p">扫描二维码登录，</p>
                    <p class="text_span_box" v-show="!canClick">
                        <span class="code_text_span">{{ timeClock }}</span>
                        <span class="code_text_span">秒后</span>
                    </p>
                    <span class="code_text_span">二维码失效</span>
                    <span class="code_text_span" v-show="canClick">请刷新页面获取</span>
                </div>
                <!-- 微信扫码切换 -->
                <div class="code_text_box">
          <span class="code_text_span code_text_weChat" @click="weChatErCode">{{
              scanCodeName
            }}</span>
                </div>
            </div>
        </template>
        <template v-if="!erCodeShow">
            <!-- <SweepCodeIdentity :userMess="userMess"></SweepCodeIdentity> -->
        </template>
    </div>
</template>

<script>
    import {
        generateQrCode,
        scanCodeInfo,
        weChatLogin,
        getNewcurrent,
        getMenuList
    } from "../../utils/interface";
    import {mapMutations} from "vuex";
    // import SweepCodeIdentity from "./sweepCodeIdentity.vue";

    export default {
        name: "generateQrCode",
        components: {},
        data() {
            return {
                erCode: "",
                ticket: "",
                // 秒数定时器
                canClick: true,
                timeClock: 120,
                fromPath: "",
                weChatshow: false,
                erCodeShow: true,
                userMess: {},
                weChatIcons: false,
            };
        },
        computed: {
            // 点击切换扫码的名字
            scanCodeName() {
                let scanCodeName = "微信扫码登录";
                if (this.weChatshow) {
                    scanCodeName = "APP扫码登录";
                }
                return scanCodeName;
            },
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                // 通过 `vm` 访问组件实例,将值传入fromPath
                vm.fromPath = from.path;
            });
        },
        created() {
            if (this.$route.query.code) {
                // 切换到二维码页面
                this.$emit("loginShow", false);
                // 展示微信二维码
                this.weChatshow = true;
                let code = {code: this.$route.query.code}
                // 发送code认证消息
                this.weChatLogin(code);
            } else {
                this.generateQrCode();
            }
        },
        methods: {
            ...mapMutations(["isLoginVuex", "vuexAllPark"]),
            // 生成二维码接口
            generateQrCode() {
                generateQrCode()
                    .then((res) => {
                        // 解析arraybuffer
                        let that = this;
                        if (res.success) {
                            that.erCode = res.data.base64Img;
                            that.ticket = res.data.ticket;
                            that.handleCountdown();
                            this.timeClock2 = setTimeout(() => {
                                this.scanCodeInfo(this.ticket);
                                clearInterval(this.timeClock2);
                            }, 500);
                        }
                    })
                    .catch((err) => {
                        console.log("err", err);
                    });
            },
            // 切换登录方式
            getSwitchUserBox() {
                this.$emit("loginShow", true);
                this.end(); // 停止轮询
            },
            // 倒计时
            handleCountdown() {
                this.canClick = false;
                this.timeClock = 120;
                this.timer = setInterval(() => {
                    this.timeClock--;
                    if (this.timeClock === 0) {
                        this.canClick = true;
                        clearInterval(this.timer);
                    }
                }, 1000);
            },
            // 是否登录的接口
            // 开始轮训
            scanCodeInfo(ticket) {
                // 将定时器名字赋值到变量中
                this.timerCode = setInterval(() => {
                    // console.log("开始轮询接口----");
                    let params = {ticket};
                    scanCodeInfo(params).then((res) => {
                        // console.log('scanCodeInfo',res );
                        let that = this;
                        let hasPermission = false;
                        if (res.success) {
                            //权限验证
                            if (res.data) {
                                that.$cookies.remove("api_access_token");
                                that.$cookies.set("api_access_token", res.data);
                                that.$cookies.set("api_token_new", res.data);
                                getNewcurrent().then((resmess) => {
                                    // console.log('userMessagesVuex', resmess);
                                    // 卖家权限
                                    if (resmess.authorities.indexOf('reviewCenterService') > -1) {
                                        this.$cookies.set("reviewExamineMess",'reviewCenterService');
                                        getMenuList().then(res => {
                                            if (res.length > 0) {
                                                window.sessionStorage.setItem('menuList', JSON.stringify(res || []))
                                                this.resetSetItem('menuActiveId', res[0].uuid)
                                                // 成功后直接跳转
                                                this.$router.push("/examine");
                                            }
                                        })
                                        hasPermission = true;
                                    } else {
                                        this.$alert('权限不足，请联系管理员!', "提示", {
                                            confirmButtonText: "确定",
                                        })
                                        // this.$router.push("/");
                                        hasPermission = false;

                                        that.end(); // 停止轮询
                                        that.canClick = true;
                                    }
                                }).catch((err) => {
                                    console.log(err);
                                });
                            }
                            if (res.data && hasPermission) {
                                that.$cookies.remove("api_access_token");
                                that.$cookies.set("api_access_token", res.data);
                                that.$cookies.set("api_token_new", res.data);
                                that.end(); // 停止轮询
                                that.isLoginVuex(true);
                                // 成功后的返回
                                that.$nextTick(() => {
                                    if (
                                        that.fromPath === "/forgetPassword" ||
                                        that.fromPath === "/registered"
                                    ) {
                                        that.$router.push("/");
                                    } else {
                                        that.$router.push('home');
                                        // that.$router.go(-1);
                                    }
                                });
                            } else {
                                console.log("您未扫码，请扫码");
                            }
                        } else {
                            that.end(); // 停止轮询
                            that.canClick = true;
                            // that.$alert(res.message, "提示", {
                            //     confirmButtonText: "确定",
                            // });
                        }
                    });
                }, 2000);
            },
            // 停止轮训
            end() {
                clearInterval(this.timeClock2)
                clearInterval(this.timerCode);
                this.timeClock2 = null;
                this.timerCode = null; // 这里最好清除一下，回归默认值
                // 众所周知，定时器返回一个随机整数，用于表示定时器的编号，后面通过名字可以取消这个定时器的执行
                console.log("结束轮询接口----");
            },
            // 微信二维码
            weChatErCode() {
                // 隐藏app扫码
                this.ticket = '';
                this.weChatshow = !this.weChatshow;
                clearInterval(this.timer);
                clearInterval(this.timerCode);
                let that = this;
                if (this.weChatshow) {
                    this.end(); // 停止轮询
                    var obj = new WxLogin({
                        id: "weixin",
                        // 应用唯一标识
                        appid: "wx5ec8c8cd93fd041d",
                        // 应用授权作用于
                        scope: "snsapi_login",
                        // 二维码样式
                        href:
                            "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE3NnB4O21hcmdpbi10b3A6MDtib3JkZXI6MH0KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAzMDBweDt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO2Rpc3BsYXk6IGZsZXg7anVzdGlmeS1jb250ZW50OiBjZW50ZXI7bWFyZ2luLXRvcDozMHB4fSAKLmltcG93ZXJCb3ggLnN0YXR1cyBwe2ZvbnQtc2l6ZToxNnB4O2ZvbnQtd2VpZ2h0OjUwMH0gCi5pbXBvd2VyQm94IC5pbmZvIC5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0=",
                        // 扫码成功后 跳转的地址
                        redirect_uri: "https://www.zengcaicloud.com/loginCode?from=review",
                    });
                } else {
                    this.generateQrCode();
                }
            },
            // 刷新页面
            refreshPage() {
                this.generateQrCode();
            },
            // 调用code活的token
            weChatLogin(code) {
                let that = this
                //是否有权限flag
                let hasPermission = false;
                weChatLogin(code).then((res) => {
                    console.log("weChatLoginres",res)

                    if (res.success) {
                        //先验证是否绑定
                        if (res.data.success) {
                            // 绑定了 验证权限
                            let tokens = res.data.token.access_token;
                            that.$cookies.remove("api_access_token");
                            that.$cookies.set("api_access_token", tokens);
                            that.$cookies.set("api_token_new", tokens);
                            getNewcurrent().then((resmess) => {
                                // console.log('userMessagesVuex', resmess);
                                // 卖家权限
                                if (resmess.authorities.indexOf('reviewCenterService') > -1) {
                                    this.$cookies.set("reviewExamineMess",'reviewCenterService');
                                    getMenuList().then(res => {
                                        if (res.length > 0) {
                                            window.sessionStorage.setItem('menuList', JSON.stringify(res || []))
                                            this.resetSetItem('menuActiveId', res[0].uuid)
                                            // 成功后直接跳转

                                            this.$router.push("/");
                                        }
                                    })
                                    hasPermission = true;
                                } else {
                                    this.$alert('权限不足，请联系管理员!', "提示", {
                                        confirmButtonText: "确定",
                                    })
                                    hasPermission = false;

                                    // 切换到登录页面
                                    this.$router.push('/login')
                                    this.$emit("loginShow", true);
                                    this.vuexAllPark(false);
                                    this.$alert(res.message, "提示", {
                                        confirmButtonText: "确定",
                                    });
                                }
                            }).catch((err) => {
                                console.log(err);
                            });

                            if (hasPermission) {
                                that.isLoginVuex(true);
                                // 成功后的返回
                                that.$nextTick(() => {
                                    if (
                                        that.fromPath === "/forgetPassword" ||
                                        that.fromPath === "/registered" ||
                                        that.fromPath === "/login"
                                    ) {

                                        that.$router.push("/");
                                    } else {
                                        that.$router.push('home');
                                        // that.$router.go(-2);
                                    }
                                });
                            }
                        } else {
                            // 未绑定 切换到用户绑定
                            this.erCodeShow = false;
                            this.userMess = res.data
                            this.$message("您未曾在增材云登录过，请先进行手机账号绑定！");
                        }
                    } else {

                        // 切换到登录页面
                        this.$router.push('/login')
                        this.$emit("loginShow", true);
                        this.vuexAllPark(false);
                        this.$alert(res.message, "提示", {
                            confirmButtonText: "确定",
                        });
                    }
                });
            },
        },
        beforeDestroy() {
            this.ticket = "";
            clearInterval(this.timeClock2)
            clearInterval(this.timer);
            clearInterval(this.timerCode);
        },
    };
</script>

<style lang="less" scoped>
    .generateQrCode {
        position: relative;

        .generateQrCode_huan {
            position: absolute;
            top: 0;
            right: -1px;
            color: #fff;
            cursor: pointer;
        }

        .generateQrCode_code {
            text-align: center;
            margin-top: 70px;
            margin-bottom: 20px;

            .code_title {
                font-size: 26px;
                color: #2b2b2b;
                margin: 0;
                margin-bottom: 29px;
            }

            .code_img_box1 {
                display: flex;
                justify-content: center;
                position: relative;
                height: 192px;

                .code_img_boxRef {
                    background: #f3f3f3e8;
                    width: 192px;
                    height: 192px;
                    position: absolute;
                    font-size: 14px;
                    font-weight: bold;
                    color: #787878;

                    p {
                        margin: 0;
                    }

                    .code_img_boxText {
                        cursor: pointer;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);

                        i {
                            font-size: 50px;
                            font-weight: bold;
                            margin-bottom: 10px;
                        }

                        .boxRef_cur {
                            color: #157efb;
                        }
                    }
                }

                .code_img_box {
                    width: 192px;
                    height: 192px;
                    background: url("../../assets/generateQrCode/lines.png");
                    background-size: 100% 100%;
                    box-sizing: border-box;
                    padding: 13px;

                    .code_img {
                        width: 166px;
                        height: 166px;
                    }
                }

                .icon_success {
                    position: absolute;
                    width: 162px;
                    height: 162px;
                    background: #f3f3f3e8;
                    line-height: 162px;
                    text-align: center;
                    top: 16px;
                    color: rgb(15, 175, 0);
                    font-size: 60px;
                }
            }

            .code_img_box2 {
                height: 258px;
                position: relative;

                .code_img_box2_img {
                    width: 192px;
                    height: 192px;
                    position: absolute;
                }

                #weixin {
                    margin-top: 9px;
                }
            }

            .code_text_box {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 43px;

                p {
                    margin: 0;
                }

                .code_text_span {
                    font-weight: bold;
                    color: #157efb;
                }

                .code_text_weChat {
                    cursor: pointer;
                    z-index: 99;
                }

                .icon38_msg {
                    display: none;
                }

                /deep/ .impowerBox .icon38_msg.succ {
                    display: none !important;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/login/generateQrCode.vue